// extracted by mini-css-extract-plugin
export default {"root":"segmentedControl_root__ERoUn","control":"segmentedControl_control__gq5Sk","indicator":"segmentedControl_indicator__znfSU"};